module.exports = "pegasus/assets/circle-twitter.png";